import Choice from "../../Choice/Choice"


import Paper from "../../../assets/images/icon-paper.svg"
import Scissors from "../../../assets/images/icon-scissors.svg"
import Rock from "../../../assets/images/icon-rock.svg"
import Traingle from "../../../assets/images/bg-triangle.svg"
import { setChoice } from "../../../Redux/Game/gameActions"

const Choices = () => {
    return (
        <div className='mt-36 w-3/4 mx-auto max-w-sm game-container'>
            <div className="image-container">
                <img src={Traingle} alt="background"></img>
            </div>
            <div className="paper">
                <Choice variant="paper">
                    <img src={Paper} alt="paper"/>
                </Choice>
            </div>
            <div className="scissors"  >
                <Choice variant="scissors">
                    <img src={Scissors} alt="scissors"/>
                </Choice>
            </div>
            <div className="rock">
                <Choice variant="rock">
                    <img src={Rock} alt="rock"/>
                </Choice>
            </div>
        </div>
    )
}


export default Choices